import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import { useTranslation } from 'react-i18next';
import PlayArrow from '@material-ui/icons/PlayArrow';
import ConfirmDialog from 'modules/ui/component/ConfirmDialog';
import { IconButton, Tooltip, TableCell } from '@material-ui/core';

import RunOptimizationDialog from './RunOptimizationDialog';

function RunOptimizationCaseButton(props) {
	const dispatch = useDispatch();
	const { t } = useTranslation('optimizationCase');
	const [openDialog, setOpenDialog] = useState(false);

	return (
		<TableCell className="w-auto text-center" padding="none">

			<Tooltip title={t('run')}>
				<span>
					<IconButton onClick={e => { setOpenDialog(true); }}>
						<PlayArrow fontSize="small" />
					</IconButton>
				</span>
			</Tooltip>

			{openDialog && (
				<RunOptimizationDialog
					optimizationCase={props.item}
					onCancel={() => setOpenDialog(false)}
					onSave={result => { setOpenDialog(false); }}
				/>
			)}

		</TableCell>
	);
}

export default RunOptimizationCaseButton;
